import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    getResponseData,
    MULTIPART_CONFIG,
    validateSchemaFields
} from 'lib/formUtils';
import {
    appendFieldsToFormData,
    formatDateForInput,
    getCodUsuarioRegistrou,
    getCurrencyInputValue,
    getInputValue,
    getOnlyDigits,
    isMissingValue,
    parseCurrencyInputValue,
    validateField
} from 'lib/functions';
import {
    Box,
    CardContent,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    Select,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import {
    CancelOutlined,
    CheckCircleOutlined
} from '@material-ui/icons';
import theme from 'theme';
import api from 'services/api';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { safeSetState } from 'lib/reactUtils';
import { validateComboFields } from 'lib/configUtils';
import { AABASTECIMENTO_EXTERNO, AABASTECIMENTO_INTERNO } from 'consts';
import { ComboPadrao, FormActions, FormTextArea } from 'views/Components';
import { handleDeleteIconMouseEnter, handleDeleteIconMouseLeave } from 'lib/uiUtils';

class AbastecimentoForm extends Component {
    state = {
        abastecimento: {
            codabastecimento: '',
            codveiculo: '',
            codfuncionario: '',
            codcategoriacombustivel: '',
            codcombustivel: '',
            data: '',
            codprojeto: '',
            tipoabastecimento: '',
            descricao: '',
            volumeabastecimento: '',
            valor: '',
            precoporlitro: '',
            kmatual: '',
            nronf: '',
            codpostocombustivel: '',
            codbomba: '',
            hora: '',
            kmspercorridoabastecimento: '',
            consumoabastecimento: '',
            origem: '',
            listacp: ''
        },
        errors: {},
        errorsModal: {},
        veiculos: [],
        motoristas: [],
        categoriascombustivel: [],
        combustiveis: [],
        projetos: [],
        postos: [],
        bombas: [],
        isNewRecord: false,
        isView: false,
        openAlert: false,
        messageAlert: '',
        openMotivoModal: false,
        schema: {
            data: {
                presence: {
                    allowEmpty: false,
                    message: 'Data obrigatória'
                },
                length: { maximum: 10 },
                type: 'date'
            },
            codveiculo: {
                presence: {
                    allowEmpty: false,
                    message: 'Veículo obrigatório'
                },
                length: { maximum: 100 },
                type: 'integer'
            },
            kmatual: {
                presence: {
                    allowEmpty: false,
                    message: 'Hodômetro inválido'
                },
                length: { maximum: 100 },
                type: 'integer'
            },
            volumeabastecimento: {
                presence: {
                    allowEmpty: false,
                    message: 'Volume obrigatório'
                },
                length: { maximum: 100 },
                type: 'number'
            },
            valor: {
                presence: {
                    allowEmpty: false,
                    message: 'Valor total obrigatório'
                },
                length: { maximum: 100 },
                type: 'number'
            },
            codfuncionario: {
                presence: {
                    allowEmpty: false,
                    message: 'Motorista obrigatório'
                },
                length: { maximum: 100 },
                type: 'integer'
            },
            codcombustivel: {
                presence: {
                    allowEmpty: false,
                    message: 'Combustível obrigatório'
                },
                length: { maximum: 100 },
                type: 'integer'
            },
            codcategoriacombustivel: {
                presence: {
                    allowEmpty: false,
                    message: 'Categoria de combustível obrigatória'
                },
                length: { maximum: 100 },
                type: 'integer'
            },
            codpostocombustivel: {
                presence: {
                    allowEmpty: false,
                    message: 'Posto de combustível obrigatório'
                },
                length: { maximum: 100 },
                type: 'integer'
            },
            codbomba: {
                presence: {
                    allowEmpty: false,
                    message: 'Bomba interna obrigatória'
                },
                length: { maximum: 100 },
                type: 'integer'
            },
            descricao: {
                presence: {
                    allowEmpty: false,
                    message: 'Descrição motivo abastecimento obrigatória'
                },
                length: { maximum: 5000 },
                type: 'string'
            }
        }
    };

    _isMounted = false;
    safeSetState = safeSetState;

    /* Altera a cor do ícone de confirmação */
    handleConfirmIconMouseEnter = (event) => {
        event.currentTarget.style.color = theme.palette.success.dark;
    };

    /* Retorna à cor padrão do ícone de confirmação */
    handleConfirmIconMouseLeave = (event) => {
        event.currentTarget.style.color = theme.palette.success.main;
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            await this.loadCombosDefault();

            if (isNewRecord) {
                this.safeSetState({
                    isNewRecord: true,
                    isView: false,
                    abastecimento: this.getAbastecimentoDefault()
                });

                return;
            }

            if (!isNaN(Number(id))) {
                await this.loadAbastecimento(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar abastecimento:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar abastecimento!'
                )
            );
        }
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Retorna o abastecimento padrão */
    getAbastecimentoDefault = () => ({
        codabastecimento: '',
        codveiculo: '',
        codfuncionario: '',
        codcategoriacombustivel: '',
        codcombustivel: '',
        data: '',
        codprojeto: '',
        tipoabastecimento: AABASTECIMENTO_EXTERNO,
        descricao: '',
        volumeabastecimento: '',
        valor: '',
        precoporlitro: '',
        kmatual: 0,
        nronf: '',
        codpostocombustivel: '',
        codbomba: '',
        hora: '',
        kmspercorridoabastecimento: '',
        consumoabastecimento: '',
        origem: '',
        listacp: ''
    });

    /* Carrega os dados dos combos */
    loadCombosDefault = async () => {
        const paramsVeiculo = '?page=1&limit=500&veiculoproprio=S';
        const paramsMotorista = '?page=1&limit=500&funcionario=S';
        const paramsPosto = '?page=1&limit=500&postocombustivel=S';

        const [
            veiculos,
            motoristas,
            postos,
            categoriascombustivel,
            combustiveis,
            projetos,
            bombas
        ] = await Promise.all([
            api.get(`/veiculo/active/true${paramsVeiculo}`),
            api.get(`/fornecedor/active/true${paramsMotorista}`),
            api.get(`/fornecedor/active/true${paramsPosto}`),
            api.get('/categoriacombustivel/active/true'),
            api.get('/combustivel/active/true'),
            api.get('/financas/projeto/active/true'),
            api.get('/bomba/active/true')
        ]);

        this.safeSetState({
            veiculos: this.formatVeiculos(getResponseData(veiculos)),
            motoristas: getResponseData(motoristas),
            postos: getResponseData(postos),
            categoriascombustivel: getResponseData(categoriascombustivel),
            combustiveis: getResponseData(combustiveis),
            projetos: getResponseData(projetos),
            bombas: getResponseData(bombas)
        });
    };

    /* Formata os veículos para a exibição */
    formatVeiculos = (veiculos) => (
        (veiculos || []).map(item => ({
            ...item,
            placanroveiculo: item.placa && item.nroveiculo
                ? `${item.placa} [${item.nroveiculo}]`
                : (item.nroveiculo || '')
        }))
    );

    /* Carrega o abastecimento */
    loadAbastecimento = async (id, isView) => {
        const response = await api.get(`/abastecimento/${id}`);
        const dados = getRecordFromResponse(response) || {};

        const [
            categoriascombustivel,
            combustiveis,
            projetos,
            bombas
        ] = await Promise.all([
            api.get(`/categoriacombustivel/listforchange/${dados.codcategoriacombustivel}`),
            api.get(`/combustivel/listforchange/${dados.codcombustivel}`),
            api.get(`/financas/projeto/listforchange/${dados.codprojeto}`),
            api.get(`/bomba/listforchange/${dados.codbomba}`)
        ]);

        this.safeSetState({
            categoriascombustivel: getResponseData(categoriascombustivel),
            combustiveis: getResponseData(combustiveis),
            projetos: getResponseData(projetos),
            bombas: getResponseData(bombas),
            abastecimento: {
                ...dados,
                data: dados.data ? formatDateForInput(dados.data) : '',
                tipoabastecimento: String(dados.tipoabastecimento || AABASTECIMENTO_EXTERNO),
                descricao: dados.descricao || '',
                kmatual: dados.kmatual === undefined ? null : dados.kmatual
            },
            isNewRecord: false,
            isView
        });
    };

    /* Calcula o preço por litro */
    calculatePricePerLiter = (abastecimento) => {
        const volume = parseFloat(abastecimento.volumeabastecimento);
        const valorTotal = parseFloat(abastecimento.valor);

        if (Number.isNaN(volume) || Number.isNaN(valorTotal) || volume <= 0 || valorTotal <= 0) {
            return;
        }

        return (valorTotal / volume).toFixed(2);
    };

    /* Evento onChange componentes */
    onChange = async (event) => {
        const { name, value, type, checked } = event.target;

        this.setState(prevState => {
            const novo = {
                ...prevState.abastecimento,
                [name]: type === 'checkbox' ? checked : value
            };

            // preenche automaticamente o combustível vinculado ao veículo
            if (name === 'codveiculo') {
                const veiculoSelecionado = prevState.veiculos.find(
                    item => String(item.codveiculo) === String(value)
                );

                if (veiculoSelecionado && veiculoSelecionado.codcombustivel) {
                    novo.codcombustivel = veiculoSelecionado.codcombustivel;
                } else {
                    novo.codcombustivel = '';
                }

                if (veiculoSelecionado && veiculoSelecionado.codprojeto) {
                    novo.codprojeto = veiculoSelecionado.codprojeto;
                } else {
                    novo.codprojeto = '';
                }
            }

            // troca o tipo de abastecimento
            if (name === 'tipoabastecimento') {
                if (value === AABASTECIMENTO_EXTERNO) {
                    novo.codbomba = '';
                }

                if (value === AABASTECIMENTO_INTERNO) {
                    novo.codpostocombustivel = '';
                }
            }

            novo.precoporlitro = this.calculatePricePerLiter(novo);

            return { abastecimento: novo };
        });

        if (name === 'tipoabastecimento' && value === AABASTECIMENTO_INTERNO) {
            const response = await api.get('/bomba/active/true');

            this.setState({ bombas: getResponseData(response) });
        }
    };

    /* Abre o modal de motivo de abastecimento */
    handleOpenMotivoModal = () => {
        this.setState({
            openMotivoModal: true,
            errorsModal: {}
        });
    };

    /* Fecha o modal de motivo de abastecimento */
    handleCloseMotivoModal = () => {
        this.setState({
            openMotivoModal: false,
            errorsModal: {}
        });
    };

    /* Muda a descrição do motivo de abastecimento */
    handleChangeDescricaoMotivo = (event) => {
        const { value } = event.target;

        this.setState(prevState => ({
            abastecimento: {
                ...prevState.abastecimento,
                descricao: value
            },
            errorsModal: {
                ...prevState.errorsModal,
                descricao: ''
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { abastecimento, isNewRecord } = this.state;

        const errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        const comboErrors = validateComboFields(abastecimento, [
            {
                field: 'codveiculo',
                message: 'Selecione um veículo válido'
            },
            {
                field: 'codfuncionario',
                message: 'Selecione um motorista válido'
            },
            {
                field: 'codcategoriacombustivel',
                message: 'Selecione uma categoria de combustível válida'
            },
            {
                field: 'codcombustivel',
                message: 'Selecione um combustível válido'
            },
            ...(abastecimento.tipoabastecimento === AABASTECIMENTO_EXTERNO
                ? [{
                    field: 'codpostocombustivel',
                    message: 'Selecione um posto de combustível válido'
                }]
                : []),
            ...(abastecimento.tipoabastecimento === AABASTECIMENTO_INTERNO
                ? [{
                    field: 'codbomba',
                    message: 'Selecione uma bomba interna válida'
                }]
                : [])
        ]);

        if (Object.keys(comboErrors).length > 0) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    ...comboErrors
                }
            }));

            this.handleOpenAlert('Selecione registros válidos nos campos indicados em vermelho!');

            return;
        }

        if (isNewRecord) {
            this.handleOpenMotivoModal();

            return;
        }

        await this.handleSubmitAbastecimento();
    };

    /* Confirma o motivo do abastecimento */
    handleConfirmMotivoModal = async () => {
        const { abastecimento, schema } = this.state;
        const descricaoError = validateField('descricao', abastecimento.descricao, schema);

        if (descricaoError) {
            this.setState({
                errorsModal: {
                    descricao: descricaoError
                }
            });

            return;
        }

        this.setState({
            openMotivoModal: false,
            errorsModal: {}
        });

        await this.handleSubmitAbastecimento();
    };

    /* Retorna o payload do abastecimento */
    getPayloadAbastecimento = () => {
        const { abastecimento, isNewRecord } = this.state;
        const codusuarioregistrou = getCodUsuarioRegistrou();

        if (isMissingValue(codusuarioregistrou)) {
            throw new Error('Código do usuário não encontrado!');
        }

        const fields = {
            data: abastecimento.data || '',
            valor: abastecimento.valor || '',
            kmatual: abastecimento.kmatual || '',
            codusuarioregistrou: Number(codusuarioregistrou),
            codveiculo: abastecimento.codveiculo || '',
            volumeabastecimento: abastecimento.volumeabastecimento || '',
            codfuncionario: abastecimento.codfuncionario || '',
            codcombustivel: abastecimento.codcombustivel || '',
            codbomba: abastecimento.codbomba || '',
            codcategoriacombustivel: abastecimento.codcategoriacombustivel || '',
            tipoabastecimento: abastecimento.tipoabastecimento || '',
            hora: abastecimento.hora || '',
            codpostocombustivel: abastecimento.codpostocombustivel || '',
            nronf: abastecimento.nronf || '',
            precoporlitro: abastecimento.precoporlitro || '',
            kmspercorridoabastecimento: abastecimento.kmspercorridoabastecimento || '',
            consumoabastecimento: abastecimento.consumoabastecimento || '',
            origem: abastecimento.origem || '',
            codprojeto: abastecimento.codprojeto || '',
            listacp: abastecimento.listacp || ''
        };

        if (isNewRecord) {
            fields.descricao = abastecimento.descricao || '';
        }

        return appendFieldsToFormData(fields);
    };

    /* Clicar para enviar */
    handleSubmitAbastecimento = async () => {
        const { abastecimento, isNewRecord } = this.state;
        const { history } = this.props;

        try {
            const formData = this.getPayloadAbastecimento();

            if (isNewRecord) {
                await api.post(
                    '/abastecimento',
                    formData,
                    MULTIPART_CONFIG
                );
            } else {
                await api.put(
                    `/abastecimento/${abastecimento.codabastecimento}`,
                    formData,
                    MULTIPART_CONFIG
                );
            }

            history.push('/frotas/abastecimento');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao salvar!'
                )
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/abastecimento');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { abastecimento, schema } = this.state;

        const errors = validateSchemaFields(
            abastecimento,
            schema,
            [
                'data',
                'codveiculo',
                'kmatual',
                'volumeabastecimento',
                'valor',
                'codfuncionario',
                'codcombustivel',
                'codcategoriacombustivel'
            ]
        );

        // valida os campos do schema
        const requiredFields = [
            'data',
            'codveiculo',
            'kmatual',
            'volumeabastecimento',
            'valor',
            'codfuncionario',
            'codcombustivel',
            'codcategoriacombustivel'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, abastecimento[field], schema);

            if (error) {
                errors[field] = error;
            }
        });

        // valida se o hodômetro é válido
        if (abastecimento.kmatual === 0 || abastecimento.kmatual === '0') {
            errors.kmatual = 'Hodômetro inválido';
        }

        // valida apenas o campo relacionado ao tipo de abastecimento
        if (abastecimento.tipoabastecimento === AABASTECIMENTO_INTERNO) {
            const codbombaError = validateField('codbomba', abastecimento.codbomba, schema);

            if (codbombaError) {
                errors.codbomba = 'Bomba interna obrigatória';
            }
        }

        if (abastecimento.tipoabastecimento === AABASTECIMENTO_EXTERNO) {
            const codpostocombustivelError = validateField(
                'codpostocombustivel',
                abastecimento.codpostocombustivel,
                schema
            );

            if (codpostocombustivelError) {
                errors.codpostocombustivel = 'Posto de combustível obrigatório';
            }
        }

        return errors;
    };

    /* Trata os campos com vírgula */
    handleChangeValorMonetario = (e, campo) => {
        const numero = parseCurrencyInputValue(e.target.value);

        this.setState(prevState => {
            const novo = {
                ...prevState.abastecimento,
                [campo]: numero
            };

            novo.precoporlitro = this.calculatePricePerLiter(novo);

            return { abastecimento: novo };
        });
    };

    /* Aceita somente dígitos */
    handleNumericChange = (event) => {
        const { name, value } = event.target;

        this.setState(prevState => ({
            abastecimento: {
                ...prevState.abastecimento,
                [name]: getOnlyDigits(value)
            }
        }));
    };

    /* Altera o volume do abastecimento */
    handleChangeVolumeAbastecimento = (event) => {
        this.handleChangeValorMonetario(event, 'volumeabastecimento');
    };

    /* Altera o valor total do abastecimento */
    handleChangeValorTotal = (event) => {
        this.handleChangeValorMonetario(event, 'valor');
    };

    render() {
        const {
            abastecimento,
            bombas,
            categoriascombustivel,
            combustiveis,
            errors,
            errorsModal,
            isView,
            messageAlert,
            motoristas,
            openAlert,
            openMotivoModal,
            postos,
            projetos,
            veiculos
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Typography
                        component="h1"
                        variant="h3"
                    >
                        Abastecimento {abastecimento.codabastecimento}
                    </Typography>

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                flex: 1,
                                minWidth: 220
                            }}
                        >
                            <ComboPadrao
                                name={'codveiculo'}
                                label={'Veículo'}
                                value={abastecimento.codveiculo}
                                onChange={this.onChange}
                                fieldId={'codveiculo'}
                                listItems={veiculos}
                                fieldDescription={'placanroveiculo'}
                                helperText={errors.codveiculo || ''}
                                error={!!errors.codveiculo}
                            />
                        </FormControl>

                        <TextField
                            label="Hodômetro (km rodados)"
                            name="kmatual"
                            value={getInputValue(abastecimento.kmatual)}
                            variant="outlined"
                            onChange={this.handleNumericChange}
                            disabled={isView}
                            inputProps={{
                                inputMode: 'numeric',
                                pattern: '[0-9]*',
                                maxLength: 6
                            }}
                            helperText={errors.kmatual || ''}
                            error={!!errors.kmatual}
                            style={{
                                flex: 1,
                                minWidth: 220
                            }}
                        />
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                flex: 1,
                                minWidth: 200
                            }}
                        >
                            <ComboPadrao
                                name={'codfuncionario'}
                                label={'Motorista'}
                                value={abastecimento.codfuncionario}
                                onChange={this.onChange}
                                fieldId={'codfornecedor'}
                                listItems={motoristas}
                                fieldDescription={'descfornecedor'}
                                helperText={errors.codfuncionario || ''}
                                error={!!errors.codfuncionario}
                            />
                        </FormControl>

                        <TextField
                            label="Número Nota Fiscal"
                            name="nronf"
                            value={abastecimento.nronf || ''}
                            variant="outlined"
                            onChange={this.handleNumericChange}
                            disabled={isView}
                            inputProps={{ maxLength: 20 }}
                            style={{
                                flex: 1,
                                minWidth: 100,
                                display: (abastecimento.tipoabastecimento === AABASTECIMENTO_EXTERNO) ? '' : 'none'
                            }}
                        />
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                flex: 1,
                                minWidth: 150
                            }}
                        >
                            <ComboPadrao
                                name={'codcategoriacombustivel'}
                                label={'Categoria de Combustível'}
                                value={abastecimento.codcategoriacombustivel}
                                onChange={this.onChange}
                                fieldId={'codcategoriacombustivel'}
                                listItems={categoriascombustivel}
                                fieldDescription={'desccategoriacombustivel'}
                                helperText={errors.codcategoriacombustivel || ''}
                                error={!!errors.codcategoriacombustivel}
                            />
                        </FormControl>

                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                flex: 1,
                                minWidth: 150
                            }}
                        >
                            <ComboPadrao
                                name={'codcombustivel'}
                                label={'Combustível'}
                                value={abastecimento.codcombustivel}
                                onChange={this.onChange}
                                fieldId={'codcombustivel'}
                                listItems={combustiveis}
                                fieldDescription={'desccombustivel'}
                                helperText={errors.codcombustivel || ''}
                                error={!!errors.codcombustivel}
                            />
                        </FormControl>
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <TextField
                            label="Data"
                            name="data"
                            onChange={this.onChange}
                            type="date"
                            value={abastecimento.data || ''}
                            variant="outlined"
                            disabled={isView}
                            helperText={errors.data || ''}
                            error={!!errors.data}
                            InputLabelProps={{
                                shrink: true,
                                required: false
                            }}
                            style={{
                                flex: '0 1 130px',
                                minWidth: 140
                            }}
                        />

                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                flex: 1,
                                minWidth: 220
                            }}
                        >
                            <ComboPadrao
                                name={'codprojeto'}
                                label={'Projeto'}
                                value={abastecimento.codprojeto}
                                onChange={this.onChange}
                                fieldId={'codprojeto'}
                                listItems={projetos}
                                fieldDescription={'descprojeto'}
                            />
                        </FormControl>
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <FormControl
                            variant="filled"
                            disabled={isView}
                            style={{
                                flex: '0 1 120px',
                                minWidth: 140
                            }}
                        >
                            <InputLabel
                                htmlFor="outlined-age-native-simple"
                                shrink={true}
                                style={{ padding: '0 4px' }}
                            >
                                Tipo Abastecimento
                            </InputLabel>

                            <Select
                                label="Tipo Abastecimento"
                                native
                                onChange={this.onChange}
                                value={abastecimento.tipoabastecimento}
                                inputProps={{
                                    id: 'outlined-age-native-simple',
                                    name: 'tipoabastecimento'
                                }}
                            >
                                <option
                                    key={AABASTECIMENTO_EXTERNO}
                                    value={AABASTECIMENTO_EXTERNO}
                                >
                                    {"Externo"}
                                </option>

                                <option
                                    key={AABASTECIMENTO_INTERNO}
                                    value={AABASTECIMENTO_INTERNO}
                                >
                                    {"Interno"}
                                </option>
                            </Select>
                        </FormControl>

                        {abastecimento.tipoabastecimento === AABASTECIMENTO_EXTERNO && (
                            <FormControl
                                variant="outlined"
                                disabled={isView}
                                style={{
                                    flex: 1,
                                    minWidth: 200
                                }}
                            >
                                <ComboPadrao
                                    name={'codpostocombustivel'}
                                    label={'Posto de Combustível'}
                                    value={abastecimento.codpostocombustivel}
                                    onChange={this.onChange}
                                    fieldId={'codfornecedor'}
                                    listItems={postos}
                                    fieldDescription={'descfornecedor'}
                                    helperText={errors.codpostocombustivel || ''}
                                    error={!!errors.codpostocombustivel}
                                />
                            </FormControl>
                        )}

                        {abastecimento.tipoabastecimento === AABASTECIMENTO_INTERNO && (
                            <FormControl
                                variant="outlined"
                                disabled={isView}
                                style={{
                                    flex: 1,
                                    minWidth: 260
                                }}
                            >
                                <ComboPadrao
                                    name={'codbomba'}
                                    label={'Bomba Interna'}
                                    value={abastecimento.codbomba}
                                    onChange={this.onChange}
                                    fieldId={'codbomba'}
                                    listItems={bombas}
                                    fieldDescription={'descbomba'}
                                    helperText={errors.codbomba || ''}
                                    error={!!errors.codbomba}
                                />
                            </FormControl>
                        )}
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <TextField
                            label="Volume"
                            name="volumeabastecimento"
                            value={getCurrencyInputValue(abastecimento.volumeabastecimento)}
                            variant="outlined"
                            onChange={this.handleChangeVolumeAbastecimento}
                            disabled={isView}
                            type="text"
                            helperText={errors.volumeabastecimento || ''}
                            error={!!errors.volumeabastecimento}
                            style={{
                                flex: 1,
                                minWidth: 120
                            }}
                        />

                        <TextField
                            label="Valor Litro"
                            name="precoporlitro"
                            value={getCurrencyInputValue(abastecimento.precoporlitro)}
                            variant="outlined"
                            disabled
                            type="text"
                            style={{
                                flex: 1,
                                minWidth: 120
                            }}
                        />

                        <TextField
                            label="Valor Total"
                            name="valor"
                            value={getCurrencyInputValue(abastecimento.valor)}
                            variant="outlined"
                            onChange={this.handleChangeValorTotal}
                            disabled={isView}
                            type="text"
                            helperText={errors.valor || ''}
                            error={!!errors.valor}
                            style={{
                                flex: 1,
                                minWidth: 120
                            }}
                        />
                    </Box>

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />

                <Dialog
                    open={openMotivoModal}
                    onClose={this.handleCloseMotivoModal}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>Motivo Abastecimento</DialogTitle>

                    <DialogContent style={{ paddingBottom: 24 }}>
                        <Box style={{ marginBottom: 12 }}>
                            <FormTextArea
                                label="Descrição motivo"
                                name="descricao"
                                value={abastecimento.descricao}
                                onChange={this.handleChangeDescricaoMotivo}
                                error={errorsModal.descricao}
                                minHeight={140}
                                resize="none"
                                style={{
                                    padding: 12,
                                    borderRadius: 6
                                }}
                            />
                        </Box>

                        <Box
                            display="flex"
                            justifyContent="flex-end"
                            alignItems="center"
                            style={{ gap: 16 }}
                        >
                            <Tooltip title="OK">
                                <CheckCircleOutlined
                                    onMouseEnter={this.handleConfirmIconMouseEnter}
                                    onMouseLeave={this.handleConfirmIconMouseLeave}
                                    onClick={this.handleConfirmMotivoModal}
                                    style={{
                                        cursor: 'pointer',
                                        color: theme.palette.success.main
                                    }}
                                />
                            </Tooltip>

                            <Tooltip title="Fechar">
                                <CancelOutlined
                                    onMouseEnter={handleDeleteIconMouseEnter}
                                    onMouseLeave={handleDeleteIconMouseLeave}
                                    onClick={this.handleCloseMotivoModal}
                                    style={{
                                        cursor: 'pointer',
                                        color: 'red'
                                    }}
                                />
                            </Tooltip>
                        </Box>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
};

AbastecimentoForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object
};

export default AbastecimentoForm;